export default "dist/assets/images/2-step.5d1fbaef4085155aaf607d6cd98f490b.svg";